import React from 'react';
import Image from 'next/image';
import CreateResumeBtn from './CreateResumeBtn';
import ResumeEditImage from '@/assets/resume-marketing/resume-edit.png';

const ResumeEdit = () => {
  return (
    <div
      className="my-10 px-5 tablet:my-25"
      data-ele-id="content"
      data-ele-group="4th_screen"
      data-observer-id="4th_screen"
    >
      <div className="text-center">
        <p className="text-3xl font-semibold mb-4 tablet:text-4.5xl">
          简历编辑，专业建议助您脱颖而出
        </p>
        <p className="text-lg mb-5 tablet:text-xl tablet:mb-10">
          获取专家精心优化的简历建议，提升每个细节，快速吸引雇主关注。
        </p>
        <CreateResumeBtn dataEleGroup="4th_screen" />
      </div>
      <div className="w-full mx-auto px-5 pt-2.5 pb-1 mt-8 rounded-lg bg-[linear-gradient(108.81deg,#e2e0fd_1.19%,#b6d7ee_98.6%)] tablet:max-w-[1200px] tablet:px-21.5 tablet:pt-9 tablet:pb-2 tablet:rounded-2.5xl">
        <div className="w-full mx-auto tablet:max-w-[1082px]">
          <Image
            src={ResumeEditImage}
            alt=""
            style={{
              objectFit: 'contain',
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ResumeEdit;
